import { ArrowRight } from "@material-ui/icons";
import React from "react";

type Props = {
  setStep: (step: number) => void;
};

const StepOne = ({ setStep }: Props) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "10px",
      }}
    >
      <div>
        <p>
          Pour coller 2 polygones il faut tout d'abord sélectionner un 1er
          polygone. Ensuite, il va falloir sélectionner les points à coller.
        </p>
        <p>
          Pour cela, il faut sélectionner un 1er point, ensuite le 2ème point
          correspond au sens de rotation et une fois le dernier point
          sélectionné, tous les points entre le premier et le dernier seront
          sélectionnés.
          <br />
          <br />
          Nous vous conseillons de choisir le 2ème point proche du 1er pour
          éviter des comportements inattendus.
          <br />
          <br />
          Voici 2 exemple qui montre le comportement en fonction du 2ème point
          sélectionné :
        </p>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "10px",
        }}
      >
        <img src="/right.gif" alt="help" width="250" height="250" />
        <img src="/left.gif" alt="help" width="250" height="250" />
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          cursor: "pointer",
        }}
        onClick={() => setStep(2)}
      >
        Étape 2 <ArrowRight />
      </div>
    </div>
  );
};

export default StepOne;
